// extracted by mini-css-extract-plugin
export default {"scroll-container":"Footer_scroll-container__+IOPM","btn-scroll":"Footer_btn-scroll__gYfaI","icon":"Footer_icon__E289C","rotate":"Footer_rotate__qWbqQ","mover":"Footer_mover__YDicT"};